<template>
    <div class="container-fluid p-0">
        <div class="row no-gutters h-100">
            <!-- Mapa ocupará todo el lado izquierdo -->
            <div class="col-lg-8 col-md-7 col-12 mapa-container">
                <Departamentos />
            </div>
            <!-- Tabla ocupará el lado derecho -->
            <div class="col-lg-4 col-md-5 col-12 tabla-lateral">
                <div class="tabla-wrapper h-100">
                <table class="table table-modern m-0">
                    <thead class="tabla-header">
                        <tr>
                            <th class="col-numero">#</th>
                            <th>Departamento</th>
                            <th>Municipio</th>
                            <th>Sede</th>
                        </tr>
                    </thead>
                    <tbody v-if="loader" class="text-center">
                        <tr>
                            <td colspan="4" class="loading-cell">
                                <b-spinner label="Cargando..." variant="primary"></b-spinner>
                                <span class="loading-text">Cargando ubicaciones...</span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else class="tabla-body">
                        <tr v-for="sede, index in sedes" :key="index" class="fila-sede">
                            <td class="numero-fila">{{ index + 1 }}</td>
                            <td class="departamento">{{ sede.municipio.departamento.nombre_dpto }}</td>
                            <td class="municipio">
                                <router-link :to="'/sedes/' + sede.municipio.id" class="enlace-municipio">
                                    {{ sede.municipio.mcpio }}
                                </router-link>
                            </td>
                            <td class="sede">
                                <router-link :to="'/mapa-bloques/' + sede.id + '/' + sede.municipio.id" class="enlace-sede">
                                    {{ limpiarNombreSede(sede.nombre) }}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
        
</template>
<script>
    import Departamentos from '@/components/Mapas/Departamentos.vue';
    import axios from 'axios';
    export default { 
        props: ['nombreAlerta', 'showSemaforo'], 
        components: {
            Departamentos
        },
        data(){
            return{
                loader: true,
                sedes: [],
                visible: false
            }
        },
        mounted() {
            this.getSedes();
        },
        methods: {
            afterVisibleChange(val) {
                console.log('visible', val);
            },
            getSedes(){
                this.sedes = [];
                axios.get('/api/sedes', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.user.token}`
                    }
                })
                .then(res => {
                    // console.log(res.data)
                    this.sedes = res.data.sedes;
                    this.loader = false;
                    this.ordernarArray();
                })
                .catch(err => console.log(err))
            },
            ordernarArray(){
                this.sedes.sort((a, b) => {
                    if (a.municipio.departamento.nombre_dpto < b.municipio.departamento.nombre_dpto) return -1;
                    if (a.municipio.departamento.nombre_dpto > b.municipio.departamento.nombre_dpto) return 1;
                    return 0;
                });
            },
            showDrawer() {
                this.visible = true;
            },
            onClose() {
                this.visible = false;
            },
            limpiarNombreSede(nombre) {
                // Elimina la palabra "SEDE" del inicio del nombre
                return nombre.replace(/^SEDE\s+/i, '').trim();
            },
        },
        
    }
</script>
<style scoped>
    
    /* Layout principal - Pantalla completa */
    .container-fluid {
        height: 100vh;
        overflow: hidden;
        padding: 0;
    }

    .row.h-100 {
        height: 100vh !important;
        margin: 0;
    }

    .no-gutters {
        margin-right: 0;
        margin-left: 0;
    }

    .no-gutters > [class*="col-"] {
        padding-right: 0;
        padding-left: 0;
    }

    /* Contenedor del mapa - 67% del ancho en pantallas grandes */
    .mapa-container {
        position: relative;
        /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px;
        height: 100vh;
        overflow: hidden;
    }


    /* Panel lateral de la tabla - 33% del ancho */
    .tabla-lateral {
        background: white;
        border-left: 3px solid #4a5568;
        box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: hidden;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .tabla-wrapper {
        flex: 1;
        overflow: hidden;
        background: white;
        padding: 0;
        margin: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    /* Scrollbar personalizada para la tabla */
    .tabla-wrapper::-webkit-scrollbar {
        width: 10px;
    }

    .tabla-wrapper::-webkit-scrollbar-track {
        background: #f7fafc;
        border-radius: 5px;
    }

    .tabla-wrapper::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #4a5568, #2d3748);
        border-radius: 5px;
        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
    }

    .tabla-wrapper::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #2d3748, #1a202c);
    }

    /* Estilos de la tabla */
    .table-modern {
        margin: 0;
        padding: 0;
        font-size: 0.85rem;
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    /* Header de la tabla - Simplificado */
    .tabla-header {
        background: #f8fafc;
        border-bottom: 2px solid #e2e8f0;
        position: relative;
        margin: 0;
        padding: 0;
        flex-shrink: 0;
    }

    .tabla-header th {
        background: transparent !important;
        color: #2d3748 !important;
        font-weight: 600;
        font-size: 0.8rem;
        padding: 0.8rem 0.8rem;
        border: none;
        text-align: left;
        white-space: nowrap;
        margin: 0;
        vertical-align: middle;
    }

    /* Configuración específica para thead y tbody */
    .table-modern thead,
    .table-modern tbody {
        margin: 0;
        padding: 0;
    }

    .table-modern thead {
        flex-shrink: 0;
    }

    .table-modern tbody {
        flex: 1;
        overflow-y: auto;
    }

    .col-numero {
        width: 50px;
        text-align: center !important;
    }

    /* Celda específica del número */
    .tabla-body td:first-child {
        padding: 0.3rem;
        text-align: center;
        vertical-align: middle;
    }

    /* Cuerpo de la tabla - Simplificado */
    .tabla-body .fila-sede {
        background-color: #ffffff;
        transition: all 0.2s ease;
        border-bottom: 1px solid #e2e8f0;
        margin: 0;
        padding: 0;
    }

    .tabla-body .fila-sede:nth-child(even) {
        background-color: #f8fafc;
    }

    .tabla-body .fila-sede:hover {
        background-color: #edf2f7 !important;
        border-left: 3px solid #4a5568;
    }

    .tabla-body td {
        padding: 0.5rem 0.8rem;
        border: none;
        vertical-align: middle;
        color: #4a5568;
        font-weight: 500;
        line-height: 1.2;
        transition: all 0.2s ease;
        white-space: nowrap;
        height: 42px;
    }

    /* Columna de números - Simplificado */
    .numero-fila {
        background: #e2e8f0 !important;
        color: #4a5568 !important;
        font-weight: 600;
        text-align: center;
        border-radius: 4px;
        font-size: 0.8rem;
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        transition: all 0.2s ease;
        flex-shrink: 0;
    }

    .fila-sede:hover .numero-fila {
        background: #4a5568 !important;
        color: white !important;
    }

    /* Enlaces destacados - Simplificado */
    .enlace-municipio, .enlace-sede {
        color: #2563eb;
        text-decoration: none;
        font-weight: 600;
        transition: all 0.2s ease;
        padding: 2px 6px;
        border-radius: 4px;
        border: 1px solid transparent;
        white-space: nowrap;
        display: inline-block;
    }

    .enlace-municipio:hover, .enlace-sede:hover {
        color: #1d4ed8;
        text-decoration: none;
        background-color: #eff6ff;
        border-color: #bfdbfe;
    }

    /* Texto sin enlace (departamento) */
    .departamento {
        color: #6b7280;
        font-weight: 500;
    }

    /* Estado de carga mejorado */
    .loading-cell {
        padding: 4rem 2rem !important;
        background: linear-gradient(135deg, #f7fafc, #edf2f7) !important;
        border-radius: 15px;
        margin: 20px;
        text-align: center;
    }

    .loading-text {
        display: block;
        margin-top: 1.5rem;
        color: #4a5568;
        font-weight: 600;
        font-size: 1.1rem;
    }

    /* Estilos del mapa SVG */
    .st0 {
        fill: #ffffff;
        stroke: #4a5568;
        stroke-width: 0.8;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .st0:hover {
        fill: #f7fafc;
        stroke: #2d3748;
        stroke-width: 1.2;
        transform: scale(1.05);
        transform-origin: center;
        filter: drop-shadow(0 5px 15px rgba(74, 85, 104, 0.4));
    }

    .alerta1 {
        fill: #fed7d7 !important;
        stroke: #e53e3e !important;
        stroke-width: 1.5 !important;
        animation: pulse-red 2s infinite;
    }

    .alerta2 {
        fill: #fef5e7 !important;
        stroke: #dd6b20 !important;
        stroke-width: 1.5 !important;
        animation: pulse-orange 2s infinite;
    }

    .alerta3 {
        fill: #f0fff4 !important;
        stroke: #38a169 !important;
        stroke-width: 1.2 !important;
    }

    @keyframes pulse-red {
        0%, 100% { 
            fill-opacity: 0.8;
            transform: scale(1);
        }
        50% { 
            fill-opacity: 1;
            transform: scale(1.02);
        }
    }

    @keyframes pulse-orange {
        0%, 100% { 
            fill-opacity: 0.8;
            transform: scale(1);
        }
        50% { 
            fill-opacity: 1;
            transform: scale(1.02);
        }
    }

    /* Responsive Design Mejorado */
    @media (max-width: 1200px) {
        .tabla-header th {
            padding: 0.6rem 0.6rem;
            font-size: 0.75rem;
        }
        
        .tabla-body td {
            padding: 0.4rem 0.6rem;
            font-size: 0.8rem;
            height: 38px;
        }
        
        .tabla-body td:first-child {
            padding: 0.2rem;
        }
        
        .numero-fila {
            width: 22px;
            height: 22px;
            font-size: 0.75rem;
        }
    }

    @media (max-width: 992px) {
        .container-fluid {
            height: auto;
            min-height: 100vh;
        }

        .row.h-100 {
            height: auto !important;
            flex-direction: column;
        }

        .mapa-container {
            height: 60vh;
            min-height: 500px;
            padding: 20px;
        }

        .tabla-lateral {
            height: 40vh;
            min-height: 400px;
            border-left: none;
            border-top: 4px solid #4a5568;
            box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.15);
        }

        .svg-image {
            max-height: calc(60vh - 40px);
        }
    }

    @media (max-width: 768px) {
        .mapa-container {
            height: 50vh;
            min-height: 400px;
            padding: 15px;
        }

        .tabla-lateral {
            height: 50vh;
        }

        .tabla-header th {
            padding: 0.5rem 0.4rem;
            font-size: 0.7rem;
        }

        .tabla-body td {
            padding: 0.3rem 0.4rem;
            font-size: 0.75rem;
            height: 34px;
        }

        .tabla-body td:first-child {
            padding: 0.15rem;
        }

        .numero-fila {
            width: 20px;
            height: 20px;
            font-size: 0.7rem;
        }
    }

    @media (max-width: 576px) {
        .mapa-container {
            height: 45vh;
            min-height: 350px;
            padding: 10px;
        }

        .tabla-lateral {
            height: 55vh;
        }

        .tabla-header th {
            padding: 0.4rem 0.3rem;
            font-size: 0.65rem;
        }

        .tabla-body td {
            padding: 0.25rem 0.3rem;
            font-size: 0.7rem;
            height: 32px;
        }

        .tabla-body td:first-child {
            padding: 0.1rem;
        }

        .numero-fila {
            width: 18px;
            height: 18px;
            font-size: 0.65rem;
        }
    }
</style>
        